import { useTitle } from "@fyendalscollection/marketing/lib/useTitle";

export const PageTermsAndConditions = (): JSX.Element => {
	useTitle("Terms and Conditions");

	return (
		<>
			<h1>
				Terms and Conditions
			</h1>
			<h2>
				1 Application of Terms and Conditions
			</h2>
			<p>
				1.1 If you create a User Account or choose to access services
				via our Platform you accept and agree that you will be bound by
				these Terms and Conditions.
			</p>

			<h2 id="servicesProvided">
				2 Services Provided
			</h2>
			<p>
				2.1 Through the Platform you will have access to the following
				services (“Services”):
			</p>
			<ul>
				<li>
					Record purchases and sales of various products.
				</li>
				<li>
					View the value of these products as decided by external
					parties.
				</li>
			</ul>
			<h2 id="userAccount">
				3 User Account
			</h2>
			<p>
				3.1 In order to access the Services via this Platform you need
				to create a User Account and meet the following requirements:
			</p>
			<ul>
				<li>
					Be 18 years or older;
				</li>
				<li>
					Complete our verification process in relation to your
					identity and personal information to our satisfaction; and
				</li>
				<li>
					Meet any other requirements or provide information notified
					by us to you from time to time.
				</li>
			</ul>
			<p>
				3.2 To create a User Account, you must submit personal
				information, details and copies of documents via the Platform.
				We will rely on that information in order to provide Services to
				you.
			</p>
			<p>
				3.3 You agree to take personal responsibility for any actions in
				respect of instructions you give us through your User Account.
			</p>
			<p>
				3.4 The User Account may be used only for the provision of
				Services on your behalf.
			</p>
			<p>
				3.5 Only you may operate your User Account. You agree to keep
				any passwords, codes, or other security information safe and
				secure and not to provide that information to any other person.
				You accept that we are not responsible for any loss or damage
				you suffer as a result of a person accessing your User Account
				who you have not authorised to do so.
			</p>
			<p>
				3.6 You must report any suspected loss, theft or misuse of your
				User Account to us immediately.
			</p>
			<h2 id="paymentTerms">
				4 Payment Terms
			</h2>
			<p>
				4.1 Fyendal&apos;s Collection offers some services that are only
				available to users that subscribe to a recurring payment plan
				(“Plan”).
			</p>
			<p>
				4.2 All payments will be taken in US dollars.  If a Payment is
				made in a foreign currency you may incur currency conversion or
				other related fees.  We are not liable for any fees incurred.
			</p>
			<p>
				4.3 Payment may be made by use of Visa or Mastercard credit or
				debit cards.  Other cards may be accepted but no guarantee is
				made to the availability of this service.
			</p>
			<p>
				4.4 Fyendal&apos;s Collection reserves the right to change
				the pricing and duration of our Plans at any time without
				notice.
			</p>
			<p>
				4.5 The terms “Month” or “Monthly” describe a 30 day period when
				used in relation to the duration of a Plan.
			</p>
			<p>
				4.6 Fyendal&apos;s Collection will attempt to take payment up to
				48 hours prior to plan expiry.  It is the responsibility of the
				user to cancel the automatic renewal of their Plan prior to
				payment.
			</p>
			<p>
				4.7 Receipt of Payment will be made available via email (“Payment
				Receipt email”) in accordance with your email subscription
				preferences.
			</p>
			<p>
				4.8 It is your responsibility to ensure the payment card used
				for payment has funds available and can be charged.  We are not
				liable for any denial of service caused by inability to take or
				receive payment from you.
			</p>
			<p>
				4.9 Plans are non-transferable.
			</p>
			<p>
				4.10 We are under no obligation to verify the authenticity of
				any instruction or purported instruction given using your User
				Account without further enquiry.
			</p>
			<p>
				4.11 Any Payment made from your User Account forms a commitment,
				which once completed, cannot be subsequently amended or revoked.
				However, our acceptance of payments via the Platform and our
				execution of those payments is at our sole discretion and is
				subject to change at any time without notice.
			</p>
			<p>
				4.12 We are not liable for any losses or damages you suffer that
				result from a failure of Payment.
			</p>
			<h2 id="refundsAndDisputes">
				5 Refunds and Disputes
			</h2>
			<p>
				5.1 Requests for refunds or disputes may be submitted as a
				Support Enquiry through the Fyendal&apos;s Collection Discord
				Server.
			</p>
			<p>
				5.2 We will adhere to the requirements of our Third Party
				payment provider (Stripe) with regards to refunds and disputes.
			</p>
			<p>
				5.3 Where a refund or dispute is submitted outside of the terms
				specified by Stripe, we will evaluate on a case by case basis.
			</p>
			<ul>
				<li>
					Refunds requested for historical Plans will not be
					considered.
				</li>
				<li>
					Refunds will only be issued as required under the Consumer
					Guarantees Act 1993 or to the extent required by New Zealand
					law.
				</li>
			</ul>
			<p>
				5.4 We are not obligated to provide a refund outside of the
				terms specified in this section.
			</p>
			<h2 id="ourWebsitePolicy">
				6 Our Website Policy
			</h2>
			<p>
				6.1 You agree to receive any and all documentations,
				information, or other communications from Fyendal&apos;s Collection
				electronically through the Platform, by email, or otherwise over
				the internet.
			</p>
			<p>
				6.2 You agree that we may use the email address provided in your
				application for a User Account or such other email address as
				you notify us from time to time to provide such information to
				you. Any electronic communication will be deemed to have been
				received by you when it is transmitted by us.
			</p>
			<p>
				6.3 Access to the Platform is at our absolute discretion. You
				acknowledge that access to our Platform may be interrupted and
				the Services may be unavailable in certain circumstances.
			</p>
			<h2 id="useAndDisclosureOfInformation">
				7 Use and Disclosure of Information
			</h2>
			<p>
				7.1 You authorise us to:
			</p>
			<ul>
				<li>
					Collect, hold and disclose personal information about you
					for the purpose of providing Services to you, creating your
					User Account and for our own Marketing purposes;
				</li>
				<li>
					Aggregate and anonymise your data along with that of other
					users, and use that data to improve the Fyendal&apos;s Collection
					Platform;
				</li>
				<li>
					Keep records of all information and other communications
					submitted by you via the Platform or by email;
				</li>
				<li>
					Record and retain copies of all information and documents to
					the fullest extent permitted by applicable New Zealand law;
				</li>
			</ul>
			<p>
				7.2 You agree to give us any information we ask you for if we
				(or any affiliated or third parties with whom you are dealing
				with through us) believe we need it in order to comply with any
				laws in New Zealand. You agree that we can use information that
				we have to:
			</p>
			<ul>
				<li>
					Assess whether we will provide you with a User Account;
				</li>
				<li>
					Provide you with, or manage any of, our Services;
				</li>
				<li>
					Comply with any laws in New Zealand applying to us or the
					Services we provide to you; or
				</li>
				<li>
					Compare with publicly available information about you or
					information held by other reputable companies or
					organisations we have a continuing relationship with, for
					any of the above reasons.
				</li>
			</ul>
			<p>
				7.3 You agree that we can obtain information about you or give
				your information to any of the following people or
				organisations:
			</p>
			<ul>
				<li>
					Our agents or Third Parties (whether in New Zealand,
					or overseas) that provide services to, through, or via us
					such as execution, data hosting (including cloud-based
					storage providers) and processing, tax service, anti-money
					laundering services or support services; or
				</li>
				<li>
					A regulator or exchange for the purposes of carrying out its
					statutory functions.
				</li>
			</ul>
			<p>
				7.4 You agree that where required to help us comply with laws
				in New Zealand or overseas or if we believe giving the
				information will help prevent fraud, money laundering or other
				crimes, we may give information we hold about you to others
				including:
			</p>
			<ul>
				<li>
					Police or government agencies in New Zealand and overseas; or
				</li>
				<li>
					The issuers of Financial Products in order for them to
					satisfy their obligations under New Zealand anti-money
					laundering laws and regulations.
				</li>
			</ul>
			<p>
				7.5 We may not be allowed to tell you if we do give out
				information about you. We are not responsible to you or anyone
				else if we give information for the purposes above. We will not
				disclose information about you except as authorised by you or as
				required or authorised by law.
			</p>
			<h2 id="privacyActAndYourPersonalInformation">
				8 Privacy Act and your personal information
			</h2>
			<p>
				8.1 We are bound by and adhere to the New Zealand Privacy Act
				2020 for personal information to which that Act relates and
				the Privacy Principles. These Principles govern how we collect,
				use, hold and disclose your personal information. We can change
				our Privacy Policy from time to time. The updated policy will be
				made available on our website and Platform.
			</p>
			<p>
				8.2 You agree to check for any changes or, otherwise, by
				continuing to use the Platform you are considered to have
				accepted any updated policy.
			</p>
			<p>
				8.3 You have rights of access to, and correction of, personal
				information supplied to and held by us.
			</p>
			<h2 id="limitationOfLiability">
				9 Limitation of Liability
			</h2>
			<p>
				9.1 You agree that where our Services are acquired for business
				purposes, or where you hold yourself out as acquiring our
				Services for business purposes, the Consumer Guarantees Act
				1993 (“the CGA”) will not apply to any supply of products or
				services by us to you. Nothing in these Terms and Conditions
				will limit or abrogate your rights and remedies under the CGA
				except to the extent that contracting out is permitted under the
				CGA and all provisions of these Terms and Conditions will be
				modified to the extent necessary to give effect to that
				intention.
			</p>
			<p>
				9.2 Subject to any terms implied by law which cannot be excluded
				and in the absence of our fraud or wilful default, we will not
				be liable in contract, tort (including negligence), equity, or
				otherwise for any direct, indirect, incidental, consequential,
				special or punitive damage, or for any loss of profit, income or
				savings, or any costs or expenses incurred or suffered by you or
				any other person in respect of Services supplied to you or in
				connection with your use of our Platform.
			</p>
			<p>
				9.3 You acknowledge that we are entitled to rely on Information
				from Third Parties and we are under no obligation to verify or
				investigate that information. We will not be liable under any
				circumstances where we rely on Information from Third Parties;
			</p>
			<p>
				9.4 We will be under no liability for any loss or expense which
				arises as a result of a delay by us in executing a Transaction
				via the Platform (due to a network outage, system failure or
				otherwise or for any reason whatsoever).
			</p>
			<p>
				9.5 We will not be liable for any failure to provide products or
				services to you or to perform our obligations to you under these
				Terms and Conditions if such failure is caused by any event of
				force majeure beyond our reasonable control, or the reasonable
				control of our employees, agents or contractors. For the
				purposes of this clause, an event of force majeure includes
				(but is not limited to) a network outage, a failure or
				limitation with any Third Party services, a failure of any
				computer system or an inability to obtain the necessary services
				for the proper conduct of business.
			</p>
			<p>
				9.6 We will not be liable for any losses or other financial
				hardships caused by decisions made by you through standard use
				of our products.  Any information presented is for informational
				purposes only and does not constitute financial advice.  In
				particular, any decisions based on the amounts displayed in our
				&quot;Ev Tracker&quot; tool are made at your own risk.
			</p>
			<p>
				9.7 The provisions of this section will extend to all our
				employees, agents and contractors, and to all corporate entities
				in which we may have an interest.
			</p>
			<h2 id="terminationOfYourUserAccount">
				10 Termination of your User Account
			</h2>
			<p>
				10.1 Either you or we may cancel your User Account at any time.
				If you wish to cancel your User Account you may do so by
				submitting a Support Enquiry through the Fyendal&apos;s Collection
				Discord Server.
			</p>
			<p>
				10.2 Examples of when we will cancel your User Account include
				(but are not limited to):
			</p>
			<ul>
				<li>
					In order to comply with a court order;
				</li>
				<li>
					If you have acted (or we have reasonable grounds to suspect
					that you are about to act) unlawfully;
				</li>
				<li>
					If you have breached these Terms and Conditions;
				</li>
				<li>
					If you are insolvent or in liquidation or bankruptcy.
				</li>
			</ul>
			<p>
				10.3 If either you or we terminate your User Account you will
				still be responsible for any Transaction made up to the time of
				termination, and Fees for Services rendered to you and our
				rights under these Terms and Conditions in respect of those
				matters will continue to apply accordingly.
			</p>
			<p>
				10.4 You agree that we will not be liable for any loss you
				suffer where we act in accordance with this clause.
			</p>
			<h2 id="assignment">
				11 Assignment
			</h2>
			<p>
				11.1 You agree that these Terms and Conditions bind you
				personally and you may not assign any of your rights or
				obligations under it. Any such purported assignment will be
				ineffective.
			</p>
			<p>
				11.2 We may assign all or any of our rights, and transfer all or
				any of our obligations under these Terms and Conditions to any
				person, including a purchaser of the Platform or a majority of
				our business.
			</p>
			<h2 id="indemnity">
				12 Indemnity
			</h2>
			<p>
				12.1 You must, on demand being made by us and our partners,
				affiliated persons, officers and employees (including the
				Platform Provider and any employees, agents and contractors of
				the Platform Provider), indemnify those persons against any and
				all losses, costs, claims, damages, penalties, fines, expenses
				and liabilities:
			</p>
			<ul>
				<li>
					in the performance of their duties or exercise of their
					authorities, except to the extent arising as a result of
					their own negligence, fraud or wilful default; and
				</li>
				<li>
					which they may incur or suffer as a result of:
				</li>
				<li>
					relying in good faith on, and implementing instructions
					given by any person using your User Account, unless there
					are reasonable grounds for us to doubt the identity or
					authority of that person; and
				</li>
				<li>
					relying in good faith on information you have either
					provided to us or made available to us.
				</li>
				<li>
					If any person who is not you (except for the Commerce
					Commission or any other regulatory authority of competent
					jurisdiction) makes any claim, or brings any proceedings in
					any Court, against us in connection with Services we provide
					to you, you will indemnify us for and against, and pay to us
					on demand, all legal costs and other expenses that we incur
					in connection with that claim or proceeding.
				</li>
			</ul>
			<h2 id="amendments">
				13 Amendments
			</h2>
			<p>
				13.1 We may, at our sole discretion, amend these Terms and
				Conditions by giving notice to you either by:
			</p>
			<ul>
				<li>
					Notice on our website and/or Platform and/or Fyendal&apos;s
					Collection Discord Server; or
				</li>
				<li>
					Direct communication with you via email, unless the change
					is immaterial (e.g. drafting and typographical amendments).
				</li>
			</ul>
			<p>
				13.2 If you access the Platform or otherwise use our Services
				after an amendment made in accordance with clause 13.1 you will
				be deemed to have accepted the amended Terms and Conditions.
			</p>
			<h2 id="governingLawAndJurisdiction">
				14 Governing Law and Jurisdiction
			</h2>
			<p>
				14.1 These Terms and Conditions are governed by and construed
				according to the current laws of New Zealand. The parties agree
				to submit to the non-exclusive jurisdiction of the Courts of
				New Zealand.
			</p>
			<p>
				14.2 If you bring any claim or proceeding against us in any
				Court which is not a Court of New Zealand, you will indemnify us
				for and against, and pay to us on demand, all legal costs and
				other expenses that we incur in connection with that claim or
				proceeding.
			</p>
			<h2 id="generalInterpretation">
				15 General Interpretation
			</h2>
			<p>
				15.1 In these Terms and Conditions:
			</p>
			<ul>
				<li>
					Unless the context otherwise requires, references to:
				</li>
				<li>
					“we”, “us”, “our” refer to Fyendal&apos;s Collection; and
				</li>
				<li>
					“you”, “your” and “yourself” are references to the Client
					and where appropriate any person who you have advised us are
					authorised to act on your behalf.
				</li>
				<li>
					A reference to these Terms and Conditions (including these
					Terms and Conditions) includes a reference to that agreement
					as novated, altered or replaced from time to time;
				</li>
				<li>
					A reference to a party includes the party&apos;s administrators,
					successors and permitted assigns;
				</li>
				<li>
					Words in the plural include the singular and vice versa;
				</li>
				<li>
					Headings are inserted for convenience only and will be
					ignored in construing these Terms and Conditions;
				</li>
				<li>
					References to any legislation includes statutory
					regulations, rules, orders or instruments made pursuant to
					that legislation and any amendments, re-enactments, or
					replacements; and
				</li>
				<li>
					Expressions referring to writing will be construed as
					including references to words printed, typewritten, or by
					email or otherwise traced, copied or reproduced.
				</li>
			</ul>
			<p>
				15.2 These Terms and Conditions are intended to benefit and be
				enforceable by Fyendal&apos;s Collection in accordance with the Contract and
				Commercial Law Act 2017.
			</p>
		</>
	);
};
